import { routes } from '@/app/routing/router'
import { FarcanaProfileView } from './view'
const currentRoute = routes.farcanaProfile

const FarcanaProfileRoute = {
  route: currentRoute,
  view: FarcanaProfileView,
}

export { currentRoute, FarcanaProfileRoute }
